










import { Component, Mixins } from "vue-property-decorator";
import { DrawableItemEditorMixin } from "../mixins";
import QuotationEditor from "./QuotationEditor.vue";

@Component({
  components: {
    quotationEditor: QuotationEditor,
  },
})
export default class MovableImagePropertyEditor extends Mixins(DrawableItemEditorMixin) {
}
